import {useEffect} from 'react';

/**
 * Blendet Karten beim Scrollen ein (fügt `className` hinzu, sobald sie
 * sichtbar werden). Ohne IntersectionObserver werden sie sofort angezeigt.
 */
export default function useReveal(ref, selector, className) {
  useEffect(() => {
    const root = ref.current;
    if (!root) return undefined;
    const cards = Array.from(root.querySelectorAll(selector));
    if (!('IntersectionObserver' in window)) {
      cards.forEach((c) => c.classList.add(className));
      return undefined;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(className);
            io.unobserve(entry.target);
          }
        });
      },
      {threshold: 0.18, rootMargin: '0px 0px -40px 0px'}
    );
    cards.forEach((c, idx) => {
      c.style.setProperty('--delay', `${idx * 90}ms`);
      io.observe(c);
    });
    return () => io.disconnect();
  }, [ref, selector, className]);
}
